import { z } from 'zod';

export const activityLogActorSchema = z.object({
    id: z.number(),
    displayName: z.string(),
});

export const activityLogEntrySchema = z.object({
    id: z.number(),
    actor: activityLogActorSchema,
    entity_type: z.string(),
    entity_id: z.number(),
    action: z.string(),
    title: z.string(),
    description: z.string().optional().default(''),
    target_url: z.string().optional().default(''),
    metadata: z.record(z.any()).optional().default({}),
    created_at: z.string(),
});

export const activityLogListSchema = z.array(activityLogEntrySchema);

export type IActivityLogEntry = z.infer<typeof activityLogEntrySchema>;
